import { requireNativeModule } from 'expo-modules-core';

// TODO: Rename the package to 'ExpoTracking'
export default requireNativeModule('ExpoTrackingTransparency');
